import React, { Component } from 'react';
import { Pagination, Form, Input, Button, Table, DatePicker } from 'antd';
import { Icon, Breadcrumb, message, Checkbox, ConfigProvider } from 'antd';
import { Select, Spin, Badge, Row, Statistic, Modal } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { apis } from '../api/index.js';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import moment from 'moment';
import TableEmpty from '../components/TableEmpty.js';
import {
  getInstitutionOptions,
  ReviewIcon,
  formatRange,
  emergencyOption,
  getArea,
  showMoreSearch,
  ctBodyPart,
  fastDateOption,
  getDay,
  patientSourceOption,
  patientSourceName,
  getStateName,
  setScrollTop,
  emergencyName,
  getProvinceOption,
  isIncluded,
  getSex,
  breadBack,
  autoFresh,
  setSearchInfo,
  loadingOptionsHtml,
  breadItem,
  timeCalc,
  eventListener,
} from '../utils/index.js';
import Apply from './Apply.js';
import cloneDeep from 'lodash.clonedeep';
import throttle from 'lodash.throttle';
import _ from 'lodash';
const { Option } = Select;
const { Countdown } = Statistic;
const { RangePicker } = DatePicker;
const { confirm } = Modal;
let autoRefresh = '';
const dateFormat = 'YYYY-MM-DD';
const initState = {
  pageNum: 1,
  pageSize: 20,
  sortBy: '',
  sort: '',
  patName: '',
  patSex: undefined,
  patientSource: undefined,
  areaProvince: undefined,
  institutionId: undefined,
  emergencyFlag: undefined,
  modality: undefined,
  accessionNumber: '',
  reportUserId: undefined,
  verifyUserId: undefined,
  diagnosisDescription: undefined,
  part: undefined,
  stateSearch: [],
  timeRange: [getDay(-2, ' 0:0:0'), getDay(0, ' 23:59:59')],
  recentDays: 2,
  timeTypeVal: false,
  defineTimeType: false,
  processMins: null,
};
class ReportCT extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    setCurrentSearchInfoData: PropTypes.func,
    setApplicationData: PropTypes.func,
    user: PropTypes.object,
    current: PropTypes.object,
    applyToCertId: PropTypes.func,
    setNationalDict: PropTypes.func,
    setIDTypeDict: PropTypes.func,
    setCardTypeDict: PropTypes.func,
  };

  static defaultProps = {
    user: {},
    current: {},
  };

  constructor(props) {
    super(props);

    this.state = { ...initState };

    this.throttledApplicationList = throttle(newState => {
      this.getApplicationList(newState);
    }, 1000);

    this.formResize = throttle(() => {
      const form = document.querySelector('.ant-advanced-search-form');
      const table = document.querySelector('.ant-table-body');
      if (form && table) {
        let height = 230 + form.clientHeight;

        let newHeight = document.body.clientHeight - height;
        table.style.maxHeight = newHeight + 'px';

        const showMore = showMoreSearch(40);
        this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
      }
    }, 1000);
  }

  async componentDidMount() {
    const userInfo = this.props.user || {};

    this.setState({
      userId: userInfo.id,
      tableHeight: 0,
      autoRefreshStatus: false,
      loadingIconShow: false,
      searchLoading: false,
      total: 0,
      showModal: false,
      moreFilter: true,
      showMoreFilter: false,
      isLoading: false,
      productionId: '101',
      pageId: '10018',
      willTimeOut45: 0,
      willTimeOut25: 0,
      processMins: null,
    });

    this.pageInit();

    let _this = this;
    window.addEventListener('resize', () => _this.formResize());
    this.formResize();
  }

  pageInit = async () => {
    let roleInfo = (this.props.user.operationAuths || '').split(',');
    const isAnonymity = roleInfo.includes('S');

    const searchInfo = window.store.getState().api.current.searchInfo || {};
    const state = searchInfo.ctReportList || {};
    state.defineTimeType = state.timeTypeVal;
    const newState = Object.assign({}, initState, state);
    this.throttledApplicationList(newState);

    //从内存中读取是否开启自动刷新
    const status = searchInfo.autoRefreshStatus || true;
    this.reFreshList(status);

    // 获取省份列表
    const areaData = await getArea(0);
    //体位列表
    const CTParts = await ctBodyPart('CT');
    const MRParts = await ctBodyPart('MR');

    this.setState({
      provinceList: areaData,
      bodyPartList: [...CTParts, ...MRParts],
      roleInfo,
      isAnonymity,
    });
  };

  getUrlParams = url => {
    if (url.indexOf('?') !== -1) {
      let obj = {};
      let arr = url.slice(url.indexOf('?') + 1).split('&');
      arr.forEach(item => {
        let i = item.indexOf('=');
        obj[item.substr(0, i)] = item.substr(i + 1);
      });
      return obj;
    } else return {};
  };

  //报告状态计数
  stateCount = data => {
    apis.ctStateCount(data).then(res => {
      if (res.code === '0') {
        const newState = _.pick(res, ['willTimeOut25', 'willTimeOut45']);

        this.setState({ stateList: res.data, ...newState });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //报告医生列表
  getDoctorList = value => {
    apis.ctReportDoctorList(value).then(res => {
      this.setState({ reportDoctor: res.code === '0' ? res.data : [] });
    });
  };

  //审核医生列表
  getVerifyDoctorList = value => {
    apis.ctReviewDoctorList(value).then(res => {
      this.setState({ reviewDoctor: res.code === '0' ? res.data : [] });
    });
  };

  //列表
  getApplicationList = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);

    let post = _.pick(updatedState, [
      'pageNum',
      'pageSize',
      'patientSource',
      'modality',
      'institutionId',
      'emergencyFlag',
      'lastDay',
      'patSex',
      'reportUserId',
      'verifyUserId',
      'diagnosisDescription',
      'part',
      'areaProvince',
      'processMins',
    ]);
    post = {
      ...post,
      sortBy: updatedState.sortBy || undefined,
      sort: updatedState.sort || undefined,
      accessionNumber: updatedState.accessionNumber || undefined,
      patName: updatedState.patName || undefined,
      fromTime: undefined,
      toTime: undefined,
    };
    if (updatedState.defineTimeType && updatedState.timeRange) {
      const [startTime, endTime] = formatRange(updatedState.timeRange);
      post = { ...post, startTime, endTime };
    } else if (updatedState.recentDays !== undefined) {
      const dayRange = timeCalc(updatedState.recentDays);
      post = {
        ...post,
        startTime: dayRange.fromTime,
        endTime: dayRange.toTime,
      };
    }

    const stateSearch = updatedState.stateSearch;
    let [invalidFlag, state] = [false, updatedState.stateSearch];
    if (stateSearch.length === 0) {
      [invalidFlag, state] = [false, undefined];
    } else if (stateSearch.length > 0 && stateSearch.indexOf(-1) >= 0) {
      const i = updatedState.stateSearch.indexOf(-1);
      let newState = cloneDeep(updatedState.stateSearch);
      newState.splice(i, 1);
      [invalidFlag, state] = [true, newState];
    }
    post = { ...post, invalidFlag, state };

    this.stateCount(post);
    apis.ctApplicationList(post).then(res => {
      this.setState({ loadingIconShow: false, searchLoading: false });
      if (res.code === '0') {
        res.data.list.forEach((item, index) => (item.id = index));
        this.setState({ reportList: res.data.list, total: res.data.total });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  handleShowApplyModal = (record, viewType) => {
    const _this = this;
    if (viewType === 'add') {
      confirm({
        title: '提示',
        content: `该病例含有${record.seriesCnt}个序列，${record.imageCnt}张图像，请先确认是否上传完成！`,
        okText: '确认申请',
        okType: 'primary',
        cancelText: '取消',
        onOk() {
          _this.apply(record, viewType);
        },
      });
    } else {
      this.apply(record, viewType);
    }
  };

  apply = (record, viewType) => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0003' };
    if (viewType === 'add') {
      eventData.elementId = 'ns-003';
      this.setState({ isLoading: true });
      apis.ctApply(record.diagId).then(res => {
        this.setState({ isLoading: false });
        if (res.code === '0') {
          this.setState({
            showModal: true,
            current: record,
            viewType,
          });
        } else {
          message.error(res.message);
          if (res.code === '1009') this.props.history.push('/login');
        }
      });
    } else {
      switch (record.state) {
        case 10:
          eventData.elementId = 'ns-005';
          break;
        case 11:
          eventData.elementId = 'ns-007';
          break;
        case 12:
          eventData.elementId = 'ns-009';
          break;
        case 20:
        case 25:
          eventData.elementId = 'ns-011';
          break;
        case 21:
        case 26:
          eventData.elementId = 'ns-013';
          break;
        case 22:
        case 42:
          eventData.elementId = 'ns-015';
          break;
        case 30:
        case 201:
        case 46:
        case 251:
          eventData.elementId = 'ns-018';
          break;
        default:
          break;
      }
      this.setState({ showModal: true, current: record, viewType });
    }
    eventListener(eventData, true);
  };

  handleCancel = changed => {
    if (changed) this.throttledApplicationList();
    this.setState({ showModal: false });
  };

  //自动刷新列表
  reFreshList = status => {
    const _this = this;
    setTimeout(() => _this.setState({ autoRefreshStatus: status }), 5);

    if (status) {
      autoRefresh = setInterval(function() {
        if (!document.getElementById('reportList')) {
          clearInterval(autoRefresh);
        } else {
          const newState = { pageNum: _this.state.pageNum };
          _this.throttledApplicationList(newState);
        }
      }, 60 * 1000);
    } else {
      clearInterval(autoRefresh);
    }
  };
  handleProcess = (e, value) => {
    e.preventDefault();
    const { processMins } = this.state;

    this.setState({ processMins: processMins === value ? null : value });

    setTimeout(() => this.handleSearch(e), 10);
  };
  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let newState = _.pick(values, [
          'patName',
          'patSex',
          'emergencyFlag',
          'patientSource',
          'timeRange',
          'modality',
          'accessionNumber',
          'diagnosisDescription',
          'part',
          'stateSearch',
          'recentDays',
          'reportUserId',
          'verifyUserId',
          'areaProvince',
        ]);
        newState = {
          ...newState,
          pageNum: 1,
          institutionId: (values.institutionName || []).join(','),
          defineTimeType: this.state.timeTypeVal,
          timeTypeVal: this.state.timeTypeVal,
          processMins: this.state.processMins,

          //加载动画
          loadingIconShow: true,
          searchLoading: true,
        };
        this.throttledApplicationList(newState);
        setSearchInfo(newState, 'ctReportList', this);
        setScrollTop();
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    this.setSearchEvent('ns-065');
    const loadingState = { searchLoading: true };
    const newState = Object.assign({}, initState, loadingState);
    this.setState(newState);
    this.props.form.resetFields();
    this.getInstitutionData();
    this.throttledApplicationList(newState);
    setSearchInfo(initState, 'ctReportList', this);
    setScrollTop();
  };

  //分页
  pageOnChange = pageNum => {
    setScrollTop();
    const newState = { pageNum, searchLoading: true };
    setSearchInfo(newState, 'ctReportList', this);
    this.throttledApplicationList(newState);
  };

  //获取机构列表
  getInstitutionData = (name, area) => {
    const post = { institutionName: name, areaProvince: area };
    apis.ctInstitutionRecord(post).then(res => {
      this.setState({ institutionData: res.code === '0' ? res.data : [] });
    });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    const area = this.state.areaProvince;
    this.getInstitutionData(value, area);
  };

  //作废
  setUpdateValid = (record, flag) => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0003' };
    eventData.elementId = flag === 1 ? 'ns-004' : 'ns-021';
    eventListener(eventData, true);

    this.setState({ isLoading: true });
    apis.ctUpdateValid(record.diagId, flag).then(res => {
      this.setState({ isLoading: false });
      message.success(res.code === '0' ? '操作成功' : res.message);
      if (res.code === '0') this.throttledApplicationList();
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //修改报告
  undoReport = record => {
    this.setState({ isLoading: true });
    apis.ctUndoReport(record.diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') this.toReport(record, 'rewrite');
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //修改审核
  undoVerify = record => {
    this.setState({ isLoading: true });
    apis.ctUndoVerify(record.diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') this.toReport(record, 'rereview');
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //查看影像
  toImageView = record => {
    this.props.setApplicationData(record);
    let url = `/viewer/ct/study/${record.studyUid}/${record.diagId}`;
    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;

    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${xpwidth},height=${xpheight}`;
    window.open(url, 'report', str);
  };

  downloadDcm = async record => {
    message.loading('正在打包', 0);

    apis.ctDownloadDcm(record.diagId).then(url => {
      message.destroy();
      url = `/ai-web-ct${url}`;
      message.info('正在下载', 3);
      let link = document.createElement('a');
      link.href = url;
      let name = url.split('/');
      let len = name.length;
      name = name[len - 1];
      link.download = name;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    });
  };

  getButtons = record => {
    const { userId, roleInfo = [] } = this.state;

    let buttons = [];
    const { state } = record;
    const svgIconStyle = { verticalAlign: 'top', marginTop: '3px' };
    const applyInfoBtn = {
      label: '申请单',
      color: 'btn-blue',
      icon: <Icon type="file" theme="filled" />,
      handle: () => this.handleShowApplyModal(record, 'detail'),
    };
    const applyBtn = {
      label: '申请',
      color: 'btn-blue',
      icon: <Icon type="file-text" theme="filled" />,
      handle: () => this.handleShowApplyModal(record, 'add'),
    };
    const notApplyBtn = {
      label: '暂不申请',
      color: 'btn-red',
      icon: <Icon type="close-circle" theme="filled" />,
      handle: () => this.setUpdateValid(record, 1),
    };
    const writeBtn = {
      label: '填写报告',
      color: 'btn-blue',
      icon: <Icon type="edit" theme="filled" />,
      handle: () => this.toReport(record, 'write', 'write'),
    };
    const writeContinueBtn = {
      label: '继续填写',
      color: 'btn-blue',
      icon: <Icon type="edit" theme="filled" />,
      handle: () => this.toReport(record, 'write', 'write1'),
    };
    const reviewBtn = {
      label: '审核',
      color: 'btn-blue',
      icon: <ReviewIcon style={svgIconStyle} />,
      handle: () => this.toReport(record, 'review', 'review'),
    };
    const reviewContinueBtn = {
      label: '继续审核',
      color: 'btn-blue',
      icon: <ReviewIcon style={svgIconStyle} />,
      handle: () => this.toReport(record, 'review', 'review1'),
    };
    const previewBtn = {
      label: '预览',
      color: 'btn-blue',
      icon: <Icon type="file-text" theme="filled" />,
      handle: () => this.toPreview(record),
    };
    const detailBtn = {
      label: '详情',
      color: 'btn-blue',
      icon: <Icon type="profile" theme="filled" />,
      handle: () => this.toReport(record, 'detail', 'detail'),
    };
    const undoReportBtn = {
      label: '修改',
      color: 'btn-blue',
      icon: <ReviewIcon style={svgIconStyle} />,
      handle: () => this.undoReport(record),
    };
    const undoVerifyBtn = {
      label: '修改',
      color: 'btn-blue',
      icon: <Icon type="edit" theme="filled" />,
      handle: () => this.undoVerify(record),
    };
    const wrongContinueBtn = {
      label: '继续填写',
      color: 'btn-blue',
      icon: <ReviewIcon style={svgIconStyle} />,
      handle: () => this.toReport(record),
    };
    const viewImageBtn = {
      label: '查看影像',
      color: 'btn-blue',
      icon: <Icon type="file-image" theme="filled" />,
      handle: this.toImageView.bind(this, record),
    };
    const downloadBtn = {
      label: '下载',
      color: 'btn-blue',
      icon: <Icon type="cloud-download" />,
      handle: this.downloadDcm.bind(this, record),
    };
    const recoverBtn = {
      label: '恢复',
      color: 'btn-viewdetail',
      icon: <Icon type="redo" />,
      handle: this.setUpdateValid.bind(this, record, 0),
    };
    const isSelfReport = record.reportUserId === userId;
    const isSelfVerify = record.verifyUserId === userId;
    const isSelfVerify2 = record.verifyUser2Id === userId;
    switch (state) {
      case 1: //待申请
        if (roleInfo.includes('Q')) buttons.push(applyBtn, notApplyBtn);
        break;
      case 10: //待报告
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        if (roleInfo.includes('M')) buttons.push(writeBtn);
        break;
      case 11: //报告中
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        if (roleInfo.includes('M') && isSelfReport)
          buttons.push(writeContinueBtn);
        break;
      case 20: {
        //待一审
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        if (roleInfo.includes('T')) buttons.push(reviewBtn);
        else if (isSelfReport) buttons.push(undoReportBtn);

        if (
          (roleInfo.includes('M') && !roleInfo.includes('T')) ||
          roleInfo.includes('T2')
        )
          buttons.push(detailBtn);

        // const flag = isIncluded(['Q', 'M'], roleInfo);
        // if (flag && record.emergencyFlag === 2 && !roleInfo.includes('T'))
        //   buttons.push(previewBtn);
        break;
      }
      case 25: {
        //待二审
        //查看申请单
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        //审核
        if (roleInfo.includes('T2')) buttons.push(reviewBtn);
        else if (isSelfVerify) buttons.push(undoVerifyBtn);
        //详情
        const flag = isIncluded(['M', 'T'], roleInfo);
        if (flag) buttons.push(detailBtn);

        //预览
        // const flag1 = isIncluded(['Q', 'M', 'T'], roleInfo);
        // if (flag1 && record.emergencyFlag === 2 && !roleInfo.includes('T2'))
        //   buttons.push(previewBtn);

        break;
      }
      case 21: //一审中
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        if (roleInfo.includes('T') && isSelfVerify)
          buttons.push(reviewContinueBtn);
        if (roleInfo.includes('T2')) buttons.push(detailBtn);
        break;
      case 26: //二审中
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        if (roleInfo.includes('T2') && isSelfVerify2)
          buttons.push(reviewContinueBtn);
        break;
      case 22: {
        //已审核
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        const flag = isIncluded(['P', 'Q', 'M', 'T', 'I'], roleInfo);
        if (flag) buttons.push(previewBtn, detailBtn);
        if (
          (roleInfo.includes('T') && isSelfVerify && !record.verifyUser2Id) ||
          (roleInfo.includes('T2') && isSelfVerify2)
        )
          buttons.push(undoVerifyBtn);
        break;
      }
      case 42: //已纠错
      case 30: //已打印
      case 46: {
        //纠错后已打印
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        const flag = isIncluded(['P', 'Q', 'M', 'T', 'I'], roleInfo);
        if (flag) buttons.push(previewBtn, detailBtn);
        break;
      }
      case 12: {
        //已拒绝
        const flag = isIncluded(['P', 'Q', 'M', 'T', 'I'], roleInfo);
        if (flag) buttons.push(applyInfoBtn, detailBtn);
        break;
      }
      case 201: //待审核已打印（夜间急诊）
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        if (isIncluded(['Q', 'M'], roleInfo)) buttons.push(previewBtn);

        if (isIncluded(['Q', 'M', 'T2'], roleInfo)) buttons.push(detailBtn);
        if (roleInfo.includes('T')) buttons.push(reviewBtn);
        break;
      case 251: //待二审已打印（夜间急诊）
        if (roleInfo.includes('Q')) buttons.push(applyInfoBtn);
        if (isIncluded(['Q', 'M'], roleInfo)) buttons.push(previewBtn);
        if (isIncluded(['Q', 'M', 'T'], roleInfo)) buttons.push(detailBtn);
        if (roleInfo.includes('T2')) buttons.push(reviewBtn);
        break;
      case 40: {
        //纠错中
        const flag = isIncluded(['M', 'T'], roleInfo);
        if (flag && userId === record.undoPrintUser)
          buttons.push(wrongContinueBtn);
        break;
      }
      default:
        break;
    }
    buttons.push(viewImageBtn);
    if (isIncluded(['M', 'T'], roleInfo)) buttons.push(downloadBtn);
    if (record.invalidFlag === 1 && roleInfo.includes('Q')) {
      buttons = [recoverBtn];
    }

    return buttons.map((item, index) => (
      <Button
        type="link"
        key={index}
        className={item.color}
        onClick={item.handle}
        disabled={item.disabled}
      >
        {item.icon}
        {item.label}
      </Button>
    ));
  };

  //进入报告详情页面
  toReport = (record, type, eventType) => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0003' };
    const { state } = record;
    switch (eventType) {
      case 'rewrite':
      case 'write':
        eventData.elementId = 'ns-006';
        break;
      case 'write1':
        eventData.elementId = 'ns-008';
        break;
      case 'rereview':
      case 'review':
        eventData.elementId = 'ns-012';
        break;
      case 'review1':
        eventData.elementId = 'ns-014';
        break;
      case 'detail':
        if (state === 12) eventData.elementId = 'ns-010';
        else if ([22, 42].includes(state)) eventData.elementId = 'ns-017';
        else if ([30, 201, 46, 251].includes(state))
          eventData.elementId = 'ns-020';
        break;
      default:
        break;
    }
    eventListener(eventData, true);

    const id = record.diagId;
    let url = '/report/ct/';
    if (['write', 'review', 'rewrite', 'rereview'].includes(type)) {
      let apiUrl = ['write', 'rewrite'].includes(type)
        ? apis.ctWriteReport(id)
        : apis.ctVerifyReport(id);
      this.setState({ isLoading: true });
      apiUrl.then(res => {
        this.setState({ isLoading: false });
        if (res.code === '0') {
          this.props.setApplicationData(record);
          url += `${id}/${res.data.state}/${res.data.applicationId}`;
          if (['rereview', 'rewrite'].includes(type)) url += '?update=1';
          this.props.history.push(url);
        } else {
          message.error(res.message);
          if (res.code === '1009') this.props.history.push('/login');
        }
      });
    } else if (type === 'detail') {
      url += `${id}/${record.state}/${record.applicationId}?detail=true`;
      this.props.history.push(url);
    } else {
      url += `${id}/${record.state}/${record.applicationId}`;
      this.props.history.push(url);
    }
  };

  //报告预览
  toPreview = record => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0003' };
    if ([22, 42].includes(record.state)) eventData.elementId = 'ns-016';
    else if ([30, 201, 46, 251].includes(record.state))
      eventData.elementId = 'ns-019';
    eventListener(eventData, true);

    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;
    const url = `/report/preview-ct/${record.applicationId}`;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${xpwidth},height=${xpheight}`;
    window.open(url, 'reportpreview', str);
  };

  getRecordBodyPart = record => {
    const list = record.parts || [];
    return list.map((item, index) => (
      <Option value={item.id} key={index} title={item.bodyPart}>
        {item.bodyPart}
      </Option>
    ));
  };

  handleChangeBodyPart = (record, value) => {
    const { reportList } = this.state;
    reportList.forEach(item => {
      if (item.diagId === record.diagId) item.checkValue = value;
    });
    this.setState({ reportList });
  };

  aiFilterClick = (url, prms) => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0003' };
    eventListener({ ...eventData, elementId: 'ns-022', prms }, true);
    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${xpwidth},height=${xpheight}`;
    window.open(url, 'nbox', str);
  };

  getColumns = () => {
    const { sortBy, sort, roleInfo = [] } = this.state;
    const isAnonymity = roleInfo.includes('S');
    let sorter = '';
    if (sort === 'asc') sorter = 'ascend';
    else if (sort === 'desc') sorter = 'descend';
    let columns = [
      { title: 'ID', dataIndex: 'diagId', key: 'diagId', width: 60 },
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: 120,
        render: patName => (isAnonymity ? '***' : patName),
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: 80,
        render: patAge => (isAnonymity ? '***' : patAge),
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: 80,
        render: patSex => (isAnonymity ? '***' : getSex(patSex)),
      },
    ];
    if (isIncluded(['M', 'T', 'T2'], roleInfo)) {
      columns.push({
        title: '剩余时间',
        key: 'lastTime',
        width: 120,
        render: record => {
          const { applicationTime, processMins, state } = record;
          const stateArr = [10, 11, 20, 21, 25, 26];
          //待报告,报告中,待一审,一审中,待二审,二审中
          //这几种状态需要倒计时，其他不需要
          if (processMins && applicationTime && stateArr.includes(state)) {
            const deadline =
              new Date(applicationTime).getTime() + processMins * 60 * 1000;
            const className =
              deadline - Date.now() <= 5 * 50 * 1000 ? 'red' : '';
            if (deadline <= Date.now())
              return <span className="red">已超时</span>;
            return (
              <Countdown title="" value={deadline} className={className} />
            );
          } else return '--';
        },
      });
    }

    columns.push(
      {
        title: '检查日期',
        dataIndex: 'studyTime',
        key: 'studyTime',
        width: 160,
        render: value => <>{value || '--'}</>,
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        defaultSortOrder: sortBy === 'studyTime' ? sorter : '',
        sortOrder: sortBy === 'studyTime' ? sorter : '',
      },

      {
        title: '急诊',
        dataIndex: 'emergencyFlag',
        key: 'emergencyFlag',
        width: 100,
        render: value => <>{emergencyName(value) || '--'}</>,
      },
      {
        title: '患者来源',
        dataIndex: 'patientSource',
        key: 'patientSource',
        width: 100,
        render: value => <>{patientSourceName(value) || '--'}</>,
      },
      {
        title: '申请日期',
        dataIndex: 'applicationTime',
        key: 'applicationTime',
        width: 160,
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        defaultSortOrder: sortBy === 'applicationTime' ? sorter : '',
        sortOrder: sortBy === 'applicationTime' ? sorter : '',
        render: value => <>{value || '--'}</>,
      }
    );

    const isApply =
      roleInfo.includes('Q') && !isIncluded(['M', 'T', 'T2'], roleInfo);

    columns.push(
      {
        title: '报告状态',
        key: 'state',
        width: 100,
        render: record => <>{getStateName(record.state, record.invalidFlag)}</>,
      },
      {
        title: '检查类型',
        dataIndex: 'modality',
        key: 'modality',
        width: 100,
        render: value => <>{value || '--'}</>,
      },
      {
        title: '检查部位',
        dataIndex: '',
        key: 'bodyPart',
        width: 120,
        render: record => <>{this.getCheckPartText(record)}</>,
      },
      { title: '序列数', dataIndex: 'seriesCnt', key: 'seriesCnt', width: 80 },
      { title: '图像数', dataIndex: 'imageCnt', key: 'imageCnt', width: 80 },
      {
        title: '操作号',
        dataIndex: 'accessionNumber',
        key: 'accessionNumber',
        width: 120,
      }
    );
    if (!isApply) {
      columns.push(
        {
          title: '报告医生',
          dataIndex: 'reportUserName',
          key: 'reportUserName',
          width: 150,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '审核医生1',
          dataIndex: 'verifyUserName',
          key: 'verifyUserName',
          width: 150,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '审核医生2',
          dataIndex: 'verifyUser2Name',
          key: 'verifyUser2Name',
          width: 150,
          render: value => <>{value || '--'}</>,
        }
      );
    }
    columns.push(
      {
        title: '申请机构',
        dataIndex: 'institutionName',
        key: 'institutionName',
        render: value => <>{(isAnonymity ? '***' : value) || '--'}</>,
      },
      {
        title: '操作',
        dataIndex: '',
        key: 'id',
        align: 'left',
        width: 200,
        fixed: 'right',
        render: record => <>{this.getButtons(record) || '--'}</>,
      }
    );

    return columns;
  };

  getCheckPartText = record => {
    if (record.state === 1 || !record.parts) return '--';
    else {
      let list = record.parts.map(item => (
        <p key={item.id}>{`${item.bodyPart}-${item.checkPosture}`}</p>
      ));
      return list;
    }
  };

  handleChangeState = e => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0002' };
    const { value, checked } = e.target;
    let elementId;
    switch (value) {
      case 1:
        elementId = checked ? 'ns-001' : 'ns-002';
        break;
      case 10:
        elementId = checked ? 'ns-003' : 'ns-004';
        break;
      case 11:
        elementId = checked ? 'ns-005' : 'ns-006';
        break;
      case 12:
        elementId = checked ? 'ns-007' : 'ns-008';
        break;
      case 20:
        elementId = checked ? 'ns-009' : 'ns-010';
        break;
      case 21:
        elementId = checked ? 'ns-011' : 'ns-012';
        break;
      case 22:
        elementId = checked ? 'ns-013' : 'ns-014';
        break;
      case 30:
        elementId = checked ? 'ns-015' : 'ns-016';
        break;
      case -1:
        elementId = checked ? 'ns-017' : 'ns-018';
        break;
      default:
        break;
    }
    eventListener({ ...eventData, elementId }, true);

    const _this = this;
    setTimeout(() => _this.handleSearch(e), 2);
  };

  handleChangeProvince = value => {
    let elementId = value === undefined ? 'ns-016' : 'ns-018';
    this.setSearchEvent(elementId);

    this.setState({ areaProvince: value });
    this.getInstitutionData('', value);
  };

  setTimeType = e => {
    this.setSearchEvent(e.target.checked ? 'ns-030' : 'ns-033');
    this.setState({ timeTypeVal: e.target.checked });
  };

  setSearchEvent = elementId => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0001' };
    eventListener({ ...eventData, elementId }, true);
  };
  setFreshEvent = e => {
    this.setSearchEvent(e.target.checked ? 'ns-062' : 'ns-063');
  };
  setBackEvent = () => {
    this.setSearchEvent('ns-066');
  };
  setStateEvent = () => {};

  getStateList = () => {
    const { stateList = [] } = this.state;
    const stateListHtml = stateList.map((item, index) => (
      <div key={index} className="search-state">
        <Badge count={item.count} overflowCount={99} showZero></Badge>
        <Checkbox value={item.state} onChange={e => this.handleChangeState(e)}>
          {item.stateName}
        </Checkbox>
      </div>
    ));
    return stateListHtml;
  };
  render() {
    let { reportList } = this.state;
    let { reportDoctor = [], reviewDoctor = [], roleInfo = [] } = this.state;
    let { institutionData, isAnonymity, tableHeight, patName } = this.state;
    let { patSex, patientSource, areaProvince, institutionId } = this.state;
    let { emergencyFlag, modality, accessionNumber, reportUserId } = this.state;
    let { verifyUserId, stateSearch, timeTypeVal, recentDays } = this.state;
    let { timeRange, isLoading, diagnosisDescription } = this.state;
    let { part, bodyPartList = [], moreFilter, showMoreFilter } = this.state;
    const { willTimeOut25, willTimeOut45, processMins } = this.state;

    institutionId = institutionId ? institutionId.split(',') : [];
    institutionId = institutionId.map(item => +item);

    const { getFieldDecorator } = this.props.form;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');

    const [from, to] = formatRange(timeRange);

    const isApply = roleInfo.includes('Q') && !isIncluded(['M', 'T'], roleInfo);

    const sexOptions = [
      { label: '男', value: 'M' },
      { label: '女', value: 'F' },
      { label: '未知', value: '0' },
    ];
    return (
      <>
        {isLoading && (
          <div className="spin-box-bg">
            <Spin indicator={<Icon type="loading" spin />} />
          </div>
        )}
        <div className="bread-crumb">
          <Breadcrumb>{breadItem(['远程诊断报告', '工作列表'])}</Breadcrumb>
          {breadBack(this)}
          {autoFresh(this)}
        </div>

        <div className="left report-list">
          {/* 搜索条件 */}
          <Form
            className={`ant-advanced-search-form${
              !moreFilter && showMoreFilter ? ' notOverflow' : ''
            }`}
            layout="inline"
            style={{ maxHeight: '40px' }}
          >
            <div className="searchBox">
              <div className="searchBoxContent">
                <Form.Item label="患者姓名" colon={false}>
                  {getFieldDecorator('patName', {
                    initialValue: patName,
                  })(
                    <Input
                      allowClear={true}
                      placeholder="请输入患者姓名"
                      style={{ width: '150px' }}
                      disabled={isAnonymity}
                      onFocus={() => this.setSearchEvent('ns-001')}
                      onChange={({ target: { value } }) => {
                        if (value === '') this.setSearchEvent('ns-002');
                      }}
                    />
                  )}
                </Form.Item>
                <Form.Item label="性别" colon={false}>
                  {getFieldDecorator('patSex', {
                    initialValue: patSex,
                  })(
                    <Select
                      allowClear={true}
                      placeholder="选择性别"
                      style={{ width: '150px' }}
                      disabled={isAnonymity}
                      onFocus={() => this.setSearchEvent('ns-003')}
                      onChange={value => {
                        let elementId;
                        if (value === undefined) elementId = 'ns-005';
                        else if (value === 'M') elementId = 'ns-006';
                        else if (value === 'F') elementId = 'ns-007';
                        else if (value === '0') elementId = 'ns-008';
                        this.setSearchEvent(elementId);
                      }}
                    >
                      {sexOptions.map((item, index) => (
                        <Option value={item.value} key={index}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
                <div className="search-unit">
                  <Form.Item
                    label={isApply ? '检查日期' : '申请日期'}
                    colon={false}
                    style={{
                      display: timeTypeVal === true ? '' : 'none',
                    }}
                  >
                    {getFieldDecorator('timeRange', {
                      initialValue:
                        from && to
                          ? [moment(from, dateFormat), moment(to, dateFormat)]
                          : null,
                    })(
                      <RangePicker
                        locale={zh_CN}
                        allowClear={true}
                        format={dateFormat}
                        placeholder={['开始时间', '结束时间']}
                        style={{ width: '210px' }}
                        onChange={() => this.setSearchEvent('ns-031')}
                      />
                    )}
                  </Form.Item>
                  <Form.Item
                    style={{
                      display: timeTypeVal === true ? 'none' : '',
                    }}
                    label={isApply ? '检查日期' : '申请日期'}
                    colon={false}
                  >
                    {getFieldDecorator('recentDays', {
                      initialValue: recentDays,
                    })(
                      <Select
                        defaultActiveFirstOption={true}
                        showArrow={false}
                        filterOption={false}
                        allowClear={true}
                        style={{ width: 240 }}
                        onFocus={() => this.setSearchEvent('ns-023')}
                        onChange={value => {
                          let elementId;
                          if (value === undefined) elementId = 'ns-025';
                          else if (value === 0) elementId = 'ns-026';
                          else if (value === 2) elementId = 'ns-027';
                          else if (value === 6) elementId = 'ns-028';
                          else if (value === 29) elementId = 'ns-029';
                          this.setSearchEvent(elementId);
                        }}
                      >
                        {fastDateOption()}
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item label="" colon={false}>
                    {getFieldDecorator('defineTimeType', {})(
                      <Checkbox
                        checked={timeTypeVal}
                        onChange={this.setTimeType}
                      >
                        自定义
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
                <Form.Item label="患者来源" colon={false}>
                  {getFieldDecorator('patientSource', {
                    initialValue: patientSource,
                  })(
                    <Select
                      allowClear={true}
                      placeholder="选择患者来源"
                      style={{ width: '150px' }}
                      onFocus={() => this.setSearchEvent('ns-009')}
                      onChange={value => {
                        let elementId;
                        if (value === undefined) elementId = 'ns-011';
                        else if (value === 0) elementId = 'ns-012';
                        else if (value === 1) elementId = 'ns-013';
                        else if (value === 2) elementId = 'ns-014';
                        this.setSearchEvent(elementId);
                      }}
                    >
                      {patientSourceOption()}
                    </Select>
                  )}
                </Form.Item>
                <div className="search-unit">
                  <Form.Item
                    label="申请机构"
                    colon={false}
                    className="form-provice"
                  >
                    {getFieldDecorator('areaProvince', {
                      initialValue: areaProvince,
                    })(
                      <Select
                        showSearch
                        placeholder="选择省份"
                        defaultActiveFirstOption={false}
                        filterOption={false}
                        notFoundContent={null}
                        allowClear={true}
                        showArrow={false}
                        style={{ width: 150 }}
                        disabled={isAnonymity}
                        onFocus={() => this.setSearchEvent('ns-015')}
                        onChange={this.handleChangeProvince}
                      >
                        {getProvinceOption(this.state.provinceList)}
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item label="" colon={false} className="form-institute">
                    {getFieldDecorator('institutionName', {
                      initialValue: institutionId,
                    })(
                      <Select
                        className="institution-selection"
                        showSearch
                        mode="multiple"
                        placeholder="请输入机构名称"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        style={{ width: 220 }}
                        allowClear={true}
                        disabled={isAnonymity}
                        onSearch={this.handleInstitutionSearch}
                        onChange={value => {
                          let elementId;
                          if (value.length === 0) elementId = 'ns-020';
                          else elementId = 'ns-022';
                          this.setSearchEvent(elementId);
                        }}
                        onFocus={() => {
                          this.handleInstitutionSearch('');
                          this.setSearchEvent('ns-019');
                        }}
                      >
                        {institutionOptions}
                      </Select>
                    )}
                  </Form.Item>
                </div>
                <Form.Item label="急诊" colon={false}>
                  {getFieldDecorator('emergencyFlag', {
                    initialValue: emergencyFlag,
                  })(
                    <Select
                      allowClear={true}
                      placeholder="选择就诊类型"
                      style={{ width: '150px' }}
                      onFocus={() => this.setSearchEvent('ns-034')}
                      onChange={value => {
                        let elementId;
                        if (value === undefined) elementId = 'ns-036';
                        else if (value === 0) elementId = 'ns-037';
                        else if (value === 1) elementId = 'ns-038';
                        else if (value === 2) elementId = 'ns-039';
                        this.setSearchEvent(elementId);
                      }}
                    >
                      {emergencyOption()}
                    </Select>
                  )}
                </Form.Item>
                <Form.Item label="检查类型" colon={false}>
                  {getFieldDecorator('modality', {
                    initialValue: modality,
                  })(
                    <Select
                      allowClear={true}
                      placeholder="选择检查类型"
                      style={{ width: '150px' }}
                      onFocus={() => this.setSearchEvent('ns-042')}
                    >
                      {['CT', 'MR'].map((item, index) => (
                        <Option value={item} key={index}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
                <Form.Item label="检查编号" colon={false}>
                  {getFieldDecorator('accessionNumber', {
                    initialValue: accessionNumber,
                  })(
                    <Input
                      allowClear={true}
                      placeholder="输入检查编号"
                      style={{ width: '150px' }}
                      onFocus={() => this.setSearchEvent('ns-049')}
                    />
                  )}
                </Form.Item>
                {!isApply && (
                  <>
                    <Form.Item label="报告医生" colon={false}>
                      {getFieldDecorator('reportUserId', {
                        initialValue: reportUserId,
                      })(
                        <Select
                          showSearch
                          onSearch={this.getDoctorList}
                          allowClear={true}
                          placeholder="选择报告医生"
                          style={{ width: '150px' }}
                          defaultActiveFirstOption={false}
                          filterOption={false}
                          onFocus={() => {
                            this.getDoctorList();
                            this.setSearchEvent('ns-050');
                          }}
                          onChange={value => {
                            let elementId;
                            if (value === undefined) elementId = 'ns-052';
                            else elementId = 'ns-053';
                            this.setSearchEvent(elementId);
                          }}
                        >
                          {reportDoctor.map((item, index) => (
                            <Option value={item.code} key={index}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item label="审核医生" colon={false}>
                      {getFieldDecorator('verifyUserId', {
                        initialValue: verifyUserId,
                      })(
                        <Select
                          showSearch
                          onSearch={this.getVerifyDoctorList}
                          allowClear={true}
                          placeholder="选择审核医生"
                          filterOption={false}
                          style={{ width: '150px' }}
                          onFocus={() => {
                            this.getVerifyDoctorList();
                            this.setSearchEvent('ns-054');
                          }}
                          onChange={value => {
                            let elementId;
                            if (value === undefined) elementId = 'ns-056';
                            else elementId = 'ns-057';
                            this.setSearchEvent(elementId);
                          }}
                        >
                          {reviewDoctor.map((item, index) => (
                            <Option value={item.code} key={index}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </>
                )}
                <Form.Item label="诊断建议" colon={false}>
                  {getFieldDecorator('diagnosisDescription', {
                    initialValue: diagnosisDescription,
                  })(
                    <Input
                      placeholder="请输入诊断建议"
                      allowClear={true}
                      style={{ width: '150px' }}
                      onFocus={() => this.setSearchEvent('ns-058')}
                    />
                  )}
                </Form.Item>
                <Form.Item label="检查部位" colon={false}>
                  {getFieldDecorator('part', {
                    initialValue: part,
                  })(
                    <Select
                      className="institution-selection"
                      placeholder="选择检查部位"
                      mode="multiple"
                      allowClear={true}
                      style={{ width: '220px' }}
                      onFocus={() => this.setSearchEvent('ns-059')}
                      onChange={value => {
                        let elementId;
                        if (value.length === 0) elementId = 'ns-061';
                        else elementId = 'ns-060';
                        this.setSearchEvent(elementId);
                      }}
                    >
                      {bodyPartList.map((item, index) => (
                        <Option value={item.code} key={index}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="searchOptBox reportList-searchOptBox">
              {showMoreFilter && (
                <Button
                  className="moreFilter"
                  type="link"
                  onClick={() => {
                    if (moreFilter) this.setSearchEvent('ns-040');
                    else this.setSearchEvent('ns-041');
                    this.setState({ moreFilter: !moreFilter });
                  }}
                  icon={moreFilter ? 'down' : 'up'}
                >
                  {moreFilter ? '展开' : '收起'}
                </Button>
              )}

              <Button
                type="primary"
                htmlType="submit"
                disabled={this.state.searchLoading}
                onClick={e => {
                  this.handleSearch(e);
                  this.setSearchEvent('ns-064');
                }}
              >
                {this.state.loadingIconShow ? (
                  <Icon type="sync" spin />
                ) : (
                  <Icon type="search" />
                )}
                搜索
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                icon="redo"
                onClick={this.handleReset}
                disabled={this.state.searchLoading}
              >
                重置
              </Button>
            </div>
          </Form>
          <Row className="report-state">
            <Form.Item label="报告状态" colon={false}>
              {getFieldDecorator('stateSearch', {
                initialValue: stateSearch,
              })(<Checkbox.Group>{this.getStateList()}</Checkbox.Group>)}
            </Form.Item>
            {isIncluded(['M', 'T', 'T2'], roleInfo) && (
              <div className="diag-process-mins">
                <Button
                  className={processMins === 90 ? 'active' : ''}
                  onClick={e => this.handleProcess(e, 90)}
                >
                  A类（90分钟内）
                  <Badge count={willTimeOut25} />
                </Button>
                <Button
                  className={processMins === 120 ? 'active' : ''}
                  onClick={e => this.handleProcess(e, 120)}
                >
                  B类（120分钟内）
                  <Badge count={willTimeOut45} />
                </Button>
              </div>
            )}
          </Row>
          <div className="history-list">
            <Table
              loading={loadingOptionsHtml(this.state.searchLoading)}
              columns={this.getColumns()}
              dataSource={reportList}
              rowKey={record => record.id}
              key={record => record.id}
              pagination={false}
              className="list-item report-list-item"
              rowClassName={record =>
                (record.refuseFlag === 1 && record.state === 10) ||
                [42, 46].includes(record.state)
                  ? 'list-red'
                  : null
              }
              scroll={{ x: 2380, y: tableHeight }}
              locale={{ emptyText: <TableEmpty /> }}
              onChange={(pagination, filters, sorter) => {
                const orderType = { descend: 'desc', ascend: 'asc' };
                const sortType = orderType[sorter.order];
                const orderField = sorter.columnKey || '';
                const newState = {
                  pageNum: 1,
                  sortBy: orderField,
                  sort: sortType,
                  searchLoading: true,
                };
                setSearchInfo(newState, 'ctReportList', this);
                this.throttledApplicationList(newState);
                const { productionId, pageId } = this.state;
                const eIdMap = {
                  studyTime: 'ns-001',
                  applicationTime: 'ns-002',
                };
                const elementId = eIdMap[orderField];
                eventListener(
                  {
                    productionId,
                    pageId,
                    moduleId: 'mk0003',
                    elementId,
                  },
                  true
                );
              }}
            />
            <ConfigProvider locale={zh_CN}>
              <Pagination
                onChange={this.pageOnChange}
                total={this.state.total}
                pageSize={20}
                className="list-page"
                current={this.state.pageNum}
                showQuickJumper
                showTotal={() => `共${this.state.total}条`}
                size="small"
              ></Pagination>
            </ConfigProvider>
          </div>
        </div>
        <Apply
          onCancel={this.handleCancel}
          current={this.state.current}
          visible={this.state.showModal}
          viewType={this.state.viewType}
          applyToCertId={this.props.applyToCertId}
          user={this.props.user}
        />
      </>
    );
  }
}

export default withRouter(Form.create()(ReportCT));
